import { Stack, Typography } from "@mui/material";
import { useGetCampaignSummaryQuery } from "../../../api";

export const SixSensBlock = ({ campaign_id }: { campaign_id: string }) => {
  const { data } = useGetCampaignSummaryQuery({
    campaign_id,
  });

  const isSixSens = data?.has_six_sense_sub;

  if (!isSixSens) return null;

  return (
    <Stack
      sx={{
        width: "100%",
        padding: "24px 16px",
        gap: "8px",
        borderRadius: "6px",
        boxShadow: "0 4px 15.8px 0 #0000001A",
      }}
    >
      <Typography
        component="span"
        variant="subtitle1"
        sx={{ color: "#255B82", fontWeight: 600 }}
      >
        6sense Partner Data
      </Typography>
      <Typography
        component="span"
        variant="subtitle1"
        sx={{ color: "#464646", maxWidth: "330px" }}
      >
        This campaign automatically receives biweekly updates from 6sense based
        on your uploaded CID.
      </Typography>
    </Stack>
  );
};
